import { useNavigate } from "react-router-dom";
import type { UsageSummary } from "@markeroo/shared";
import { ui, plural, usageLimitReached } from "@/strings";

interface UsageLimitBannerProps {
  usage: UsageSummary | null | undefined;
}

export function UsageLimitBanner({ usage }: UsageLimitBannerProps) {
  const navigate = useNavigate();

  if (!usage?.overLimit) {
    return null;
  }

  const limitLabel = plural(usage.docsLimit, ui.labels.paper.toLowerCase(), ui.labels.papers.toLowerCase());

  const handleUpgrade = () => {
    void navigate("/pricing");
  };

  return (
    <div className="bg-semantic-error text-white px-4 py-3 flex items-center justify-between gap-4">
      <div className="flex-1">
        <p className="text-sm font-medium">{usageLimitReached(usage.docsLimit, limitLabel)}</p>
        {!usage.hasActiveSubscription && (
          <p className="text-sm opacity-90">{ui.labels.upgradeProContinue}</p>
        )}
      </div>
      {!usage.hasActiveSubscription && (
        <button
          type="button"
          onClick={handleUpgrade}
          className="rounded-md bg-white px-4 py-2 text-sm font-medium text-semantic-error transition hover:bg-semantic-error-bg"
        >
          {ui.actions.upgrade}
        </button>
      )}
    </div>
  );
}
